import { Clock } from 'lucide-react'
import {
  FINANCE_AREA_META,
  type FinanceAreaKey,
} from '@/components/Financeiro/solicitacoes/financeSolicitacoesConfig'
import type { PortalTypeKey } from '@/components/Financeiro/solicitacoes/financeSolicitacoesConfig'
import type { FinanceTypeCard } from '@/hooks/useFinanceiroSolicitacoesPage'

type Props = {
  typesByArea: Map<FinanceAreaKey, FinanceTypeCard[]>
  allowedAreas: FinanceAreaKey[]
  onSelect: (key: PortalTypeKey) => void
}

export function FinanceSolicitacoesCatalog({ typesByArea, allowedAreas, onSelect }: Props) {
  return (
    <div className='space-y-8'>
      {allowedAreas.map((area) => {
        const items = typesByArea.get(area) ?? []
        const meta = FINANCE_AREA_META[area]
        if (items.length === 0) return null

        return (
          <section key={area}>
            <div className='mb-3'>
              <h2 className='text-base font-semibold text-text-primary'>{meta.label}</h2>
              <p className='text-sm text-text-muted'>{meta.description}</p>
            </div>
            <div className='grid gap-3 sm:grid-cols-2 lg:grid-cols-3'>
              {items.map((item) => (
                <button
                  key={item.key}
                  type='button'
                  onClick={() => onSelect(item.key as PortalTypeKey)}
                  className='glass-card rounded-xl p-4 text-left transition hover:border-red-500/30 hover:shadow-sm'
                >
                  <p className='font-medium text-text-primary'>{item.label}</p>
                  <p className='mt-2 flex items-center gap-1 text-xs text-text-muted'>
                    <Clock size={12} />
                    SLA {item.slaHours}h
                  </p>
                </button>
              ))}
            </div>
          </section>
        )
      })}
    </div>
  )
}
